// @ts-ignore
import { LoginEvents } from '@cirkay-eng/cirkay-components/login-events';

document.addEventListener(LoginEvents.Submit, (event) => {
	try {
		if (
			event.detail &&
			event.detail.formData &&
			event.detail.formData['fp-maillist']
		) {
			const formData = event.detail.formData;
			formData.action = 'fp_mail_signup';

			const requestData = formData;
			// @ts-ignore
			fetch(cirkay_fan_pass.ajax_url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams(requestData).toString(),
			})
				.then((response) => {
					if (response.ok) {
						return response.json();
					}
					return Promise.reject(response);
				})
				.then((data) => {})
				.catch((error) => {
					console.error('Error', error);
				});
		}
	} catch (error) {
		console.error(error);
	}
});
